export default [
  {
    path: '/rightActivityH5',
    name: 'rightActivityH5',
    meta: { title: '专享权益活动' },
    component: () => import('@/views/rightActivityH5/index.vue')
  }
]
